export const TICKET_UPDATE = "ticket_update";
export const NEW_TICKET = "ticket_add";
